/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $on = _ref.$on,
      $update = _ref.$update;

  /*
   * Inizializza variabili
   */
  var user = [];
  var notification = {};
  /*
   * Page event
   * Per impostazione predefinita visualizza gli item attivi
   * https://framework7.io/docs/router-component.html#component-page-events
   */

  $on('pageBeforeIn', function () {
    user = myApp.user();
    user.data.notifications.forEach(function (e) {
      if (e.id == props.id) {
        notification = e;
      }
    });
    console.log(notification);
    $update();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="pageName">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">Doctor Pass</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll">

      <div class="block">
        <div class="float-left margin-right padding-top-half" innerHTML="${notification.icon}"></div>
        <div class="float-right padding-top-half text-color-gray">${notification.type}</div>
        <h1>${notification.title}</h1>
        
        <h3>${notification.subtitle}</h3>
        <div innerHTML="${notification.text}"></div>
        
      </div>
     
    </div>
  </div>
`
    }
    ;
});